export default __webpack_public_path__ + "static/media/KOD0138-min.919ae406.webp";